import { SpiderStatusRepository } from '@/core/api/spiders'

const repository = new SpiderStatusRepository()

export default {
  namespaced: true,
  state: {
    loading: false,
    items: [],
  },
  actions: {
    async FETCH({ commit }) {
      commit('START_REQUEST')

      const data = await repository.$getAll()
      commit('SET', data)
    },
  },
  mutations: {
    START_REQUEST: state => {
      state.loading = true
    },
    CLEAR: state => {
      state.items = []
    },
    SET: (state, items) => {
      state.items = items
      state.loading = false
    },
  },
}
